import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import CheckboxStyles from './checkboxStyles';

const Checkbox = props => {
  const handleOnChange = () => {
    if (props.onChange) {
      props.onChange(!props.checked);
    }
  };

  return (
    <CheckboxStyles checked={props.checked} mt={props.mt} mb={props.mb} ml={props.ml} mr={props.mr}>
      <CheckboxStyles.InputStyles onChange={handleOnChange} type="checkbox" />
      {props.children}
    </CheckboxStyles>
  );
};

Checkbox.propTypes = {
  children: PropTypes.node,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  mt: PropTypes.number,
  mr: PropTypes.number,
  mb: PropTypes.number,
  ml: PropTypes.number,
};

Checkbox.defaultProps = {
  checked: undefined,
  children: undefined,
  mt: undefined,
  mr: undefined,
  mb: undefined,
  ml: undefined,
};

export const CheckboxGrid = styled.div`
  padding-bottom: 1em;
  display: grid;
`;

export const CheckboxGridTitle = styled.p`
  padding-bottom: 1em;
  font-weight: bold;
  color: ${props => props.theme.colors.primary};
`;

export default Checkbox;
